__turbopack_context__.v({
  "desc": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__desc",
  "dot": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__dot",
  "eyebrow": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__eyebrow",
  "grid": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__grid",
  "header": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__header",
  "item": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__item",
  "itemDesc": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__itemDesc",
  "itemHeader": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__itemHeader",
  "itemTitle": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__itemTitle",
  "section": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__section",
  "thumb": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__thumb",
  "thumbWrap": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__thumbWrap",
  "title": "DevelopmentSupportMaintenanceSection-module__Kj-9Ga__title",
});
